module.exports = __webpack_public_path__ + "img/gdq_gbt97_2_1985.prt.ba48c09c.jpg";